// extracted by mini-css-extract-plugin
export default {"modalSection":"ModalReviewDetail_modalSection__2ycUj","slideItem":"ModalReviewDetail_slideItem__fQIKs","buttonClose":"ModalReviewDetail_buttonClose__3NLvu"};